import React from "react";
import "./contactUs.scss";
import { useState } from "react";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    query: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Map formData keys to the API's required keys
    const apiData = {
      fullName: formData.name,
      phoneNumber: formData.phone,
      query: formData.query,
    };

    try {
      const response = await fetch(
        "https://api.fitoja.in/api/submit-contact-us-form",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(apiData),
        }
      );

      const result = await response.json(); // Parse the JSON response

      if (response.ok) {
        // Optional: clear the form after successful submission
        setFormData({
          name: "",
          phoneNumber: "",
          query: "",
        });
      } else {
      }
    } catch (error) {
      // Handle network errors (e.g., no internet connection)
      console.error("Error submitting form:", error);
    } finally {
    }
  };

  return (
    <div className="contact-container">
      <h2>Contact Us</h2>
      <form onSubmit={handleSubmit} className="contact-form">
        <label>
          Name
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Phone Number
          <input
            type="tel"
            name="phone"
            placeholder="123-456-7890"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Your Query
          <textarea
            name="query"
            placeholder="Write your message here..."
            value={formData.query}
            onChange={handleChange}
            required
          />
        </label>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default ContactUs;
